module.exports = __webpack_public_path__ + "download_googleplay.svg?7249a2483fdec616bb6640bc31ac4514";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/download_googleplay.svg
// module id = 1227
// module chunks = 6